<template>
  <v-card class="pin_modal gps_modal_content_area gps_modal__card">
    <v-card-title class="pa-5 flex-column">
      <div class="d-flex justify-end" style="width: 100%">
        <v-btn icon variant="flat" @click="$emit('close-modal', true)">
          <icon height="14" width="14">close-x</icon>
        </v-btn>
      </div>
      <h4 class="text-center mb-0">Enter Validation Code</h4>
    </v-card-title>
    <v-card-text class="pa-5 pt-0 gps_modal_content_area__text_container">
      <p v-if="!validationErrors.length" class="text-center text-body-1 mb-0">
        The 4 digit code must be entered by an attendee to redeem.
      </p>
      <template v-else>
        <v-alert 
          type="error"
          variant="outlined"
          density="compact"
          class="gps_modal_content_area__error_alert text-body-2 mb-2"
        >
          <template v-slot:prepend>
            <div class="align-self-start">
              <icon fill="red" height="20" width="20">
                exclamation-triangle
              </icon>
            </div>
          </template>
          <div v-for="(error, idx) in validationErrors" :key="`err-${idx}`">
            {{ error }}
          </div>
        </v-alert>
      </template>
      <div class="pin-container justify-center mb-3">
        <div class="pin-number">
          <div
            v-for="(num, idx) in Array.from(pinNumber)"
            :key="`pin-${idx}`"
            class="pin-number__entry pin-number__entry--entered"
          >
            {{ num }}
          </div>
          <div
            v-for="blank in 4 - pinNumber.length"
            :key="blank"
            class="pin-number__entry pin-number__entry--empty"
          >
            {{ blank ? 0 : 0 }}
          </div>
        </div>
      </div>
      <v-row class="numpad" justify="center">
        <v-col
          v-for="n in numbers"
          :key="`pin-btn-${n}`"
          class="pa-0 text-center"
          cols="4"
        >
          <template v-if="!isNaN(n)">
            <v-btn
              :id="`product_validation_pin_key_btn_${n}`"
              class="mx-auto my-1 numpad__btn numpad__btn--key pin-pad__btn"
              variant="outlined"
              @click="$emit('update-pin', n)"
            >
              {{ n }}
            </v-btn>
          </template>
          <template v-else-if="n === 'del'">
            <v-btn
              class="mx-auto my-2 numpad__btn"
              variant="text"
              @click="$emit('backspace-pin')"
            >
              <icon width="30">back-space</icon>
            </v-btn>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-5 flex-column">
      <v-btn
        id="product_validation_pin_continue_btn"
        class="pin_modal__continue_btn"
        color="primary"
        :disabled="!(pinNumber.length === 4)"
        size="large"
        :loading="isLoading"
        rounded="pill"
        variant="flat"
        width="100%"
        @click="doValidate"
      >
        Continue
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'PinPad',
  data() {
    return {
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 'noBtn', 0, 'del']
    };
  },
  props: {
    validationErrors: {
      type: Array,
      default: () => []
    },
    pinNumber: {
      type: String,
      default: ''
    }
  },
  computed: {
    isLoading() {
      return (
        !!Object.keys(this.validationErrors).length &&
        this.pinNumber.length === 4
      );
    }
  },
  methods: {
    doValidate() {
      this.loading = true;
      this.$emit('redeem');
    }
  }
};
</script>

<style lang="scss" scoped>
.v-btn--icon.v-btn--density-default {
    width: 32px;
    height: 32px;
}

.v-card-title h4 {
    font-size: 1.125rem !important;
    line-height: 1.375rem !important;
}

.gps_modal_content_area {
  border-radius: 1rem;
  font-family: inherit;

  h4 {
    font-family: inherit;
    font-weight: 600;
  }
}

:deep(.gps_modal_content_area__error_alert) {
  background-color: rgba(var(--v-theme-error), 0.18) !important;
  padding: 7px 16px !important;
  min-height: auto !important;
}

.gps_modal_content_area__text_container {
  color: rgba(var(--v-theme-on-surface), 0.6) !important;
  padding-top: 4px;
}

.pin_modal {
  background-color: rgb(var(--v-theme-surface));
  border-radius: 1rem;
}

.numpad {
  margin: 0 auto;
  width: 192px;

  &__btn {
    font-size: 1.25rem;
    height: 3.5rem;
    width: 3.5rem;

    &--key {
      border-color: rgb(var(--v-theme-on-surface));
      box-shadow: none;
      color: rgba(var(--v-theme-on-surface), 0.8) !important;
    }
  }
}

.pin-container {
  display: flex;
}

.pin-number {
  display: flex;
  flex-flow: row wrap;
  height: 2.25rem;
  width: 120px;

  &__entry {
    align-items: center;
    display: flex;
    flex: 1 0 25%;
    font-size: 2rem;
    font-weight: 400;
    justify-content: center;

    &--entered {
      color: rgba(var(--v-theme-on-surface), 0.6) !important;
    }

    &--empty {
      color: rgba(var(--v-theme-on-surface), 0.05) !important;
    }
  }
}

:deep(.rounded-xl) {
  border-radius: 2rem !important;
}

.v-card__title {
  word-break: normal;
}

.pin_modal__continue_btn {
  background-color: rgb(var(--v-theme-primary)) !important;
  box-shadow: none !important;
  color: rgb(var(--v-theme-on-primary)) !important;
  font-family: inherit !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  height: 40px !important;
  letter-spacing: 0 !important;
  text-transform: none !important;

  &.v-btn--disabled {
    background-color: #b6b6b6 !important;
    color: rgb(var(--v-theme-on-primary)) !important;
  }
}
.pin-pad__btn {
  min-width: 56px !important;
}

</style>
<style>
.pin-pad__btn .v-btn__content {
  padding-right: 2px !important;
}
</style>